export const toRem = (px) => `${(px * 0.85) / 14}rem`;
